export function buildUpsellTrackingPayload(item, index, currencyCode) {
  const variant = item?.shopifyData?.variants?.[0];
  return {
    name: item?.title,
    id: variant?.product_id,
    price: item?.cardShopifyData?.productPrice ?? variant?.price ?? null,
    quantity: 1,
    productSpecsCollection: item?.productSpecsCollection?.items || [],
    itemListName: 'Cart upsell',
    itemIndex: index,
    currencyCode,
    keune_repeat: 0,
    compare_at_price: item?.cardShopifyData?.productCompareAtPrice ?? null,
    image_url: item?.image ?? null,
  };
}

export default buildUpsellTrackingPayload;
